module.exports = "/lucky-balls/img/regular_game/header_soccer.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/regular_game/header_soccer.png
// module id = 1149
// module chunks = 0